import { Question } from "../../util/Alert";
import { FaPencil } from "react-icons/fa6";
import { FaEye, FaTrash } from "react-icons/fa";

export function GenericTable({
    data,
    columns,
    className = "",
    enableActions = false,
    keyField,
    onEdit,
    onDelete,
    disabledEdit = false,
    onView
}) {
    const handleDelete = async (row) => {
        if (await Question("Deseja realmente excluir esse item?")) {
            onDelete && onDelete(row);
        }
    };

    return (
        <div className={`w-full ${className}`}>
            {/* Desktop Table */}
            <div className="hidden sm:block overflow-x-auto rounded-lg shadow-md">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-[#462A71]">
                        <tr>
                            {enableActions && (
                                <th className="px-4 py-2 text-left text-sm font-semibold text-white">
                                    Ações
                                </th>
                            )}
                            {columns.map((col, idx) => (
                                <th
                                    key={idx}
                                    className="px-4 py-2 text-left text-sm font-semibold text-white"
                                >
                                    {col.header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                        {data.map((row, idx) => (
                            <tr key={idx} className="hover:bg-gray-50">
                                {enableActions && keyField && (
                                    <td className="px-4 py-2 flex gap-2">
                                        {!disabledEdit && (
                                            <button
                                                className="text-white bg-[#FA6300] p-1 rounded-md"
                                                onClick={() => onEdit?.(row)}
                                            >
                                                <FaPencil />
                                            </button>
                                        )}
                                        <button
                                            className="text-white bg-[#462A71] p-1 rounded-md"
                                            onClick={() => onView?.(row)}
                                        >
                                            <FaEye />
                                        </button>
                                        <button
                                            className="text-white bg-red-600 p-1 rounded-md"
                                            onClick={() => handleDelete(row)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </td>
                                )}
                                {columns.map((col, colIndex) => (
                                    <td
                                        key={colIndex}
                                        className="px-4 py-2 text-gray-800"
                                    >
                                        {col.render
                                            ? col.render(row[col.accessor], row)
                                            : row[col.accessor]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="sm:hidden flex flex-col gap-4">
                {data.map((row, idx) => (
                    <div key={idx} className="bg-white shadow rounded-lg p-4 space-y-2">
                        {columns.map((col, colIndex) => (
                            <div key={colIndex} className="flex justify-between">
                                <span className="font-semibold text-gray-700">{col.header}:</span>
                                <span className="text-gray-800">
                                    {col.render ? col.render(row[col.accessor], row) : row[col.accessor]}
                                </span>
                            </div>
                        ))}
                        {enableActions && keyField && (
                            <div className="flex gap-2 mt-2">
                                {!disabledEdit && (
                                    <button
                                        className="text-white bg-[#FA6300] p-2 rounded-md flex-1"
                                        onClick={() => onEdit?.(row)}
                                    >
                                        <FaPencil className="mx-auto" />
                                    </button>
                                )}
                                <button
                                    className="text-white bg-[#462A71] p-2 rounded-md flex-1"
                                    onClick={() => onView?.(row)}
                                >
                                    <FaEye className="mx-auto" />
                                </button>
                                <button
                                    className="text-white bg-red-600 p-2 rounded-md flex-1"
                                    onClick={() => handleDelete(row)}
                                >
                                    <FaTrash className="mx-auto" />
                                </button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
